import { render, staticRenderFns } from "./SearchDefault.vue?vue&type=template&id=6b2b9bb0"
import script from "./SearchDefault.vue?vue&type=script&lang=js"
export * from "./SearchDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports